/**
 * Makes jQuery global before anything else in app.js evaluates. ES imports run in order and before the
 * importing module's own code, and Bootstrap (its $.fn.tooltip etc.) and flatpickr ($.fn.flatpickr) only
 * attach to a jQuery that is already global when they load. So bootstrap.js imports this first.
 */
import jQuery from "jquery";

window.$ = window.jQuery = jQuery;
